
const MAX_TEXT_LEN:number=16;

export const StepThree=function(props:{taskTitle:string, taskTitleInput:string, tasksList:string[], titleAltered:(title: string) => void, taskTitleClick:() => void}){
	let isTitleValid=true;
	let errMsg='';
	if(props.taskTitleInput.length<3){
		isTitleValid=false;
		if(props.taskTitleInput.length>0)errMsg='* 3 or more characters'
	}
	for(let i=0;i<props.tasksList.length;i++){
		if(props.tasksList[i].toLowerCase()===props.taskTitleInput.toLowerCase()){
			if(props.taskTitleInput!==props.taskTitle){//prevents err when create new task
				isTitleValid=false;
				errMsg='* task already exists';
			}
		}
	}
	let isComplete=props.taskTitle!=='';
	let displayTitle=props.taskTitle.replace(/_/g, ' ');
	let displayInput=props.taskTitleInput.replace(/_/g, ' ');
	return(
		<div className='teachers-taskcreater-step'>
			<hr />
			<h3>Step 3{isComplete&&'  - Complete'}</h3>
			{isComplete===false&&<p>Enter a title for this task and then click 'Okay'.</p>}
			{isComplete===true&&<p>Title chosen: {displayTitle}</p>}
			<input id="teachers-taskcreater-input" type='text' placeholder='Title here...' value={displayInput} onChange={(e)=>props.titleAltered(e.target.value)} maxLength={MAX_TEXT_LEN}></input>
			<button disabled={!isTitleValid} onClick={()=>{props.taskTitleClick();}} className='teachers-taskcreater-button teachers-button'>Okay</button>
			<span>{errMsg}</span>
		</div>
	)
};